import React from 'react';
import './Projects.css';

const About = () => (
  <div className="innerBody">
    <h2>About Me</h2>
    <p></p>
    <div className="space">
      Human. Lifelong learner. Interested in technology, design thinking, and most importantly, helping people. Previously a professional in the architecture/engineering/construction industry with a degree in architectural (structural) engineering.
    </div>
  </div>
);

export default About;


// WEBPACK FOOTER //
// ./src/About.js